
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';

import * as Models from '@app/models/ai.model';
import * as Objects from '@core/objects';

export enum EntryType {
    question = 'question',
    answer = 'answer'
}

export interface AIEntry {
    type: EntryType;// Differentiates between question and answer entries
    value: Models.AIQuestionModel | Models.AIAnswerModel;  // Holds the actual data (either a question or an answer)
}

interface AIErrors {
    warm_up: HttpErrorResponse;
    send_question: HttpErrorResponse;
    fetch_answer: HttpErrorResponse;
}

export interface AIState {
    entries: AIEntry[];
    loading: boolean; // General loading indicator (can be improved)
    errors: AIErrors;
    initialized: boolean;
}

export const initialState: AIState = {
    entries: [],
    loading: false,
    errors: {
        warm_up: null,
        send_question: null,
        fetch_answer: null
    },
    initialized: false
};

// Feature Selector for AI State
export const selectAIState = createFeatureSelector('ai');

// Selector for all entries (questions and answers)
export const selectAllEntries = createSelector(
    selectAIState,
    (state: AIState) => state.entries
);

// Selector for questions only
export const selectQuestions = createSelector(
    selectAIState,
    (state: AIState) => state.entries.filter(entry => entry.type === EntryType.question).map(e => e.value) as Models.AIQuestionModel[]

);

// Selector for answers only
export const selectAnswers = createSelector(
    selectAIState,
    (state: AIState) => state.entries.filter(entry => entry.type === EntryType.answer).map(e => e.value) as Models.AIAnswerModel[]
);

// Selector for loading status
export const selectLoadingStatus = createSelector(
    selectAIState,
    (state: AIState) => state.loading
);

// Selector for initialized status
export const selectInitializedStatus = createSelector(
    selectAIState,
    (state: AIState) => state.initialized
);

// Selectors for errors
export const selectWarmUpError = createSelector(
    selectAIState,
    (state: AIState) => state.errors.warm_up
);

export const selectQuestionError = createSelector(
    selectAIState,
    (state: AIState) => state.errors.send_question
);

export const selectAnswerError = createSelector(
    selectAIState,
    (state: AIState) => state.errors.fetch_answer
);